import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=7c97f2c5&scoped=true&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c97f2c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c97f2c5')) {
      api.createRecord('7c97f2c5', component.options)
    } else {
      api.reload('7c97f2c5', component.options)
    }
    module.hot.accept("./UserAccount.vue?vue&type=template&id=7c97f2c5&scoped=true&", function () {
      api.rerender('7c97f2c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/UserAccount.vue"
export default component.exports